import { useContext } from "react";
import { SignalRContext } from "./signalRContext";

export const useSignalR = () => useContext(SignalRContext);
